export default "__VITE_ASSET__DsGjYJTQ__"